import React 		from 'react';
import ReactDOM 	from 'react-dom';
import Dispatcher 	from './Dispatcher';
import assign 		from 'object-assign';



var DataFeedDispatcher 	=	assign( new Dispatcher(), {

	handleViewAction 	: 	function( action ) {

		this.dispatch({

			source 	: 	'VIEW_ACTION',
			action 	: 	action

		})
	}
});

export default	DataFeedDispatcher; 






// WEBPACK FOOTER //
// ./resources/assets/js/data-feed/dispatcher/DataFeedDispatcher.js